<template>
  <v-content>
    <v-container fluid>
      <Header :title="'Inbox'" />
       <Tutor :buttonName="'Book a Tutor'" v-if="has_tutor_products"/>
      <v-row no-gutters>
      <v-row v-if='Object.keys(currentUser).length !=0  && (currentUser.roles.includes(1) || currentUser.roles.includes(3))'>
        <v-col cols='12' md='4' sm='12'>
          <v-autocomplete
              v-model="selectedGroups"
              :items="groups"
              item-value="group_id"
              item-text="group_name"
              :label="'Groups' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              :disabled="(selectedUsers.length > 0? true : false)"
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-checkbox @change="checkboxUpdated('groups')" v-model="checkAllGroups" :label="'All' | translate"></v-checkbox>
              </v-list-item>
            </template>  
            </v-autocomplete>
        </v-col> 
        <v-col cols='12' md='4' sm='12'>
          <v-autocomplete
              v-model="selectedUsers"
              :items="users"
              item-value="user_id"
              :item-text="item =>`${item.name} (${item.email})`"
              :label="'Users' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              :disabled="(selectedGroups.length > 0? true : false)"
            >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-checkbox @change="checkboxUpdated('users')" v-model="checkAllUsers" :label="'All' | translate"></v-checkbox>
            </v-list-item>
          </template>            
            
            </v-autocomplete>
        </v-col>       
        <v-col cols='12' md='4' sm='12'>
          <v-row class="mt-n3">
            <v-col cols="12" md="6" sm="12">
              <v-btn class="white--text" small :color="primary_color" @click="getInboxData()"  x-large block>
                {{ 'Search' | translate }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn class="white--text" small :color="primary_color" @click="clearFilter()"  x-large block>
                {{ 'Reset' | translate }}
              </v-btn>
            </v-col>
          </v-row>
             
        </v-col>
      </v-row> 
        <v-col cols="12">
        <v-tabs>
          <v-tab>{{ 'Messages' | translate }}</v-tab>
          <v-tab>{{ 'Items Board' | translate }}</v-tab>
          <v-tab>{{ 'Setup Items' | translate }}</v-tab>
          <v-tab v-if="Object.keys(currentUser).length !=0  && (currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-pending-exercise'))">{{ 'Pending Exercise' | translate }}</v-tab>
          <v-tab v-if="Object.keys(currentUser).length !=0  && (currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-register-participation'))" @click="getEvents()">{{ 'Register Participation' | translate }}</v-tab>
          <v-tab-item>

            <v-tabs>
            <v-tab class="message-tab" :color="grey">{{ 'Inbox' | translate }} <span class="badge" style="color: #08b907;"> ({{ isReadCount }})</span></v-tab>
            <v-tab class="message-tab" @click="getSentMessages()">{{ 'Sent' | translate }}</v-tab>
            <v-tab-item>
              <v-data-table
                v-if='inboxMessages'
                :title="title" :headers="inboxHeaders" :items="inboxMessages" :search="search" @showView="showView"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" append-icon="search" :label="'Search' | translate" single-line hide-details></v-text-field>
                </v-toolbar>       
                </template>
                <template slot="no-data">
                    {{ 'No data available' | translate }}
                </template>
                
                <template v-slot:item="{ item }">
                      <tr v-on:click="showView(item.id)" style="cursor:pointer;">
                        <td>{{ item.from_user.email }}</td>
                        <td>
                          <div v-if="item.is_read" class="pt-3">
                            <p>{{ item.subject }}</p>
                            <p class="font-weight-light">{{ stripHTML(item.body).slice(0, 50) }}...</p>
                          </div>
                          <div v-else class="pt-3">
                            <b>{{ item.subject }}</b>
                            <p><b>{{ stripHTML(item.body).slice(0, 50) }}...</b></p>
                          </div>
                        </td>
                        <td>
                          <div class="pt-3">
                            <span v-if="item.is_read">{{ 'Read' | translate }}</span>
                            <b v-else style="color: green;">{{ 'Unread' | translate }}</b>
                          </div>
                        </td>
                        <td>{{ item.created_at }}</td>
                      </tr>
                  </template>

                <template v-slot:footer.page-text="items"> 
                  {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                </template>
              </v-data-table>
            </v-tab-item>

            <v-tab-item>
              <v-data-table
                v-if='sentMessages'
                :title="title" :headers="inboxHeaders" :items="sentMessages" :search="search" @showView="showView"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" append-icon="search" :label="'Search' | translate" single-line hide-details></v-text-field>
                </v-toolbar>       
                </template>
                <template slot="no-data">
                    {{ 'No data available' | translate }}
                </template>
                
                <template v-slot:item="{ item }">
                      <tr v-on:click="showView(item.id)" style="cursor:pointer;">
                        <td>{{ item.from_user.email }}</td>
                        <td>
                          <div class="pt-3">
                            <p>{{ item.subject }}</p>
                            <p class="font-weight-light">{{ stripHTML(item.body).slice(0, 50) }}...</p>
                          </div>
                        </td>
                        <td>
                          <div class="pt-3">
                            <span>{{ 'Sent' | translate }}</span>
                          </div>
                        </td>
                        <td>{{ item.created_at }}</td>
                      </tr>
                  </template>

                <template v-slot:footer.page-text="items"> 
                  {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                </template>
              </v-data-table>
            </v-tab-item>

            </v-tabs>

          </v-tab-item>
          <v-tab-item>
            <DataTable v-if='!userdocuments.hasOwnProperty("stage_1") && !userdocuments.hasOwnProperty("stage_2")'  :title="title" :headers="headers" :items="userdocuments" :search="search" @openSettingsDialog='openSettingsDialog' @modalOpenDocument="documentOpenModal" />
            <DataTable v-if='userdocuments.hasOwnProperty("stage_1")' :title="userdocuments.hasOwnProperty('stage_1')? userdocuments.stage_1.set_name : ''" :headers="headers" :items="userdocuments.hasOwnProperty('stage_1')? userdocuments.stage_1.user_documents : []" :search="stage1search" @openSettingsDialog='openSettingsDialog' @modalOpenDocument="documentOpenModal" :settingsstatus='valid' />
            <br /><br />
            <DataTable v-if='userdocuments.hasOwnProperty("stage_2")' :title="userdocuments.hasOwnProperty('stage_2')? userdocuments.stage_2.set_name : ''" :headers="headers" :items="userdocuments.hasOwnProperty('stage_2')? userdocuments.stage_2.user_documents : []" :search="stage2search" @modalOpenDocument="documentOpenModal"  />
          </v-tab-item>
          <v-tab-item>
            <DataTable @modalOpenDocument="documentOpenModal" :headers="createdocumentheaders" :items="createdocuments" :search="createsearch"  />
          </v-tab-item>
          <v-tab-item>
            <v-data-table
            v-if='uploadedexercises'
                  :headers="exerciseheaders" :items="uploadedexercises.mandatory_exercises" :search="search"
            >
              <template v-slot:top>
                <v-card-title>
                  {{  'Pending Exercises (Mandatory)' | translate }} 
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" append-icon="search" :label="'Search' | translate" single-line hide-details></v-text-field>
                </v-toolbar>       
              </template>
              <template slot="no-data">
                  {{ 'No data available' | translate }}
              </template>
              
              <template v-slot:item="{ item }">
                    <tr v-on:click="callExercise(item.course.course_id,item,'mandatory')" style="cursor:pointer;">
                      <td>{{ item.exercise_name}}</td>
                      <td>{{ item.exercise_description}}</td>
                      <td>{{ item.user.name}}</td>
                      <td>{{ item.course.course_name}}</td>
                      <td>{{ item.course.ends_on}}</td>
                      <td>{{ item.latest_with_grade ? item.latest_with_grade.grade : 'Not yet graded' | translate }}</td>
                      <td>{{ item.latest_with_grade ? item.latest_with_grade.graded_at  : '-'}}</td>
                    </tr>
                </template>

              <template v-slot:footer.page-text="items"> 
                {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
              </template>
            </v-data-table>

            <v-data-table
            v-if='uploadedexercises'
                  :headers="exerciseheaders" :items="uploadedexercises.training_exercises" :search="search"
            >
              <template v-slot:top>
                <v-card-title>
                  {{  'Pending Exercises (Training)' | translate }} 
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" append-icon="search" :label="'Search' | translate" single-line hide-details></v-text-field>
                </v-toolbar>       
              </template>
              <template slot="no-data">
                  {{ 'No data available' | translate }}
              </template>
              
              <template v-slot:item="{ item }">
                    <tr v-on:click="callExercise(item.course.course_id,item,'training')" style="cursor:pointer;">
                      <td>{{ item.exercise_name}}</td>
                      <td>{{ item.exercise_description}}</td>
                      <td>{{ item.user.name}}</td>
                      <td>{{ item.course.course_name}}</td>
                      <td>{{ item.course.ends_on}}</td>
                      <td>{{ item.latest_with_grade ? item.latest_with_grade.grade : 'Not yet graded' | translate }}</td>
                      <td>{{ item.latest_with_grade ? item.latest_with_grade.graded_at  : '-'}}</td>
                    </tr>
                </template>

              <template v-slot:footer.page-text="items"> 
                {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item>
            <v-data-table
                  :headers="eventheaders" :items="calendarpastevents" :search="search"
            >
              <template v-slot:top>
                <v-card-title>
                  {{  'Register Participation of Users' | translate }} 
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" append-icon="search" :label="'Search' | translate" single-line hide-details></v-text-field>
                </v-toolbar>       
              </template>
              <template slot="no-data">
                  {{ 'No data available' | translate }}
              </template>
              
              <template v-slot:item="{ item }">
                    <tr v-on:click="callEventParticipation(item.id,item)" style="cursor:pointer;">
                      <td>{{ item.subject}}</td>
                      <td>{{ item.attendees.length }}</td>
                      <td>{{ convertDate(item.start.dateTime) }} {{ getTimeSlot(item.start.dateTime, item.end.dateTime) }}</td>
                    </tr>
                </template>

              <template v-slot:footer.page-text="items"> 
                {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
              </template>
            </v-data-table>
          </v-tab-item>

        </v-tabs> 

        <v-dialog v-model="settingsdialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ 'Set Filter'| translate }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <h3 class="pb-4">{{ 'Stage 1'| translate }}</h3>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Set Name' | translate"
                      v-model="set_name_stage_1"
                      :disabled="isUser"
                      :rules="stage1name"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>                     
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Show next' | translate"
                      v-model="due_days_stage_1"
                      :disabled="isUser"
                      type="number"
                      :rules="duedays1"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>                     
                    </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <h3 class="pb-4">{{ 'Stage 2'| translate }}</h3>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Set Name' | translate"
                      :disabled="isUser"
                      v-model="set_name_stage_2"
                      :rules="stage2name"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template> 
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Show from' | translate"
                      :disabled="isUser"
                      v-model="due_days_stage_2"
                      :rules="duedays2"
                      type="number"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template> 
                    </v-text-field>
                    </v-col>
                  </v-row>

                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="settingsdialog=false">{{ 'Close'| translate }}</v-btn>
              <v-btn color="blue darken-1" :disabled="isUser" text @click="clearsettings()">{{ 'Clear'| translate }}</v-btn>  
              <v-btn color="blue darken-1" :disabled="isUser" text @click="setFilter()">{{ 'Save'| translate }}</v-btn>              
            </v-card-actions>
          </v-card>
        </v-dialog>

      <v-dialog v-model="templatedialog" v-if="templatedialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline" v-if='editDocument'>{{ 'Edit document' | translate }}</v-card-title>
          <v-card-title class="headline" v-else>{{ 'Update document' | translate }}</v-card-title>
          <v-card-text>
              <v-card-text>
                <v-container>
                  <v-form id="modelform" ref="modelform">
                    <v-row>
                      <v-col v-if="documenterrors" cols="12" sm="12" md="12">
                        <v-alert
                          dense
                          v-for="(v, k) in documenterrors"
                          :key="k"
                          outlined
                          type="error"
                        >{{ k }} {{ v }}</v-alert>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                            v-model="status"
                            :items="statusvalues"
                            item-value="value"
                            item-text="text"
                            :label="'Status' | translate"
                            :rules="statusRules"
                            outlined
                            chips
                            small-chips
                            required
                            :no-data-text="$t('No data available')"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12">
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="true"

                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              :label="'Due date' | translate"
                              v-model="due_date"
                              name="due_date"
                              :rules="dateRules"
                              autocomplete="off"
                              required
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on="on"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="due_date"
                            no-title
                            scrollable
                            :locale="curLanguage.lang_code"
                            @input="menu=false"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>

                    <v-row v-if="formMessage != null">
                      <v-col cols="12" sm="12" md="12">
                        <v-alert
                          dense
                          outlined
                          type="error"
                        >{{ formMessage | translate }}</v-alert>
                      </v-col>
                    </v-row>

                    <v-tabs v-if='editDocument ==false '>
                      <v-tab @click="customForm()">{{ 'File form' | translate }}</v-tab>
                      <v-tab v-if="showCustomForm()" @click="fileForm()">{{ 'Custom form' | translate }}</v-tab>
                      <v-tab-item>
                        <v-form id="fileformData" ref="fileformData">
                        <v-row class="mt-4">
                            <v-col cols="12" sm="12">
                                <v-file-input
                                    id="document_file"
                                    name="filename"
                                    outlined
                                    chips
                                    required
                                    :label="'Select file' | translate"
                                    :rules="fileRules"
                                    @change="onFileSelectedTemplate"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-file-input>
                            </v-col>  
                            <v-col cols="12" sm="12">
                              <v-textarea
                                outlined
                                name="comment"
                                v-model="comment"
                                autocomplete="off"
                                :label="'Comment (optional)' | translate"
                              >
                              <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>
                              </v-textarea>
                            </v-col>
                        </v-row>
                        </v-form>
                      </v-tab-item>
                      <v-tab-item v-if="showCustomForm()">
                        <v-form class="mt-4" id="customformData" ref="customformData">
                          <template v-for="(data,index) in metadatakeys">
                            <h3 :key="index" v-if="showCustomHeader(data)">{{ 'Page '+data }}</h3>
                            <v-row v-for="(metadata, indexvalue) of custommetadata[data]" :key="data+indexvalue+metadata.id">
                              <v-col cols="12" sm="12" md="12"  v-if ="metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number'">
                                <v-text-field 
                                    v-if ="metadata.fieldName == 'short_text'"
                                    outlined
                                    type="text"
                                    :label="metadata.label"
                                    :id="data+indexvalue"
                                    autocomplete="off"
                                    required
                                    :rules="fieldRules"
                                    @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>                            
                                </v-text-field>
                                <v-text-field 
                                    v-else-if ="metadata.fieldName == 'number'"
                                    outlined
                                    type="number"
                                    :label="metadata.label"
                                    :id="data+indexvalue"
                                    autocomplete="off"
                                    required
                                    min="0"
                                    :rules="fieldRules"
                                    @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>                            
                                </v-text-field>
                                <v-textarea
                                  v-else-if ="metadata.fieldName == 'long_text'"
                                  outlined
                                  :id="data+indexvalue"
                                  autocomplete="off"
                                  required
                                  :label="metadata.label"
                                  :rules="fieldRules"
                                  @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-textarea>
                              </v-col>
                            </v-row>
                          </template>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-textarea
                                outlined
                                name="comment"
                                v-model="comment"
                                autocomplete="off"
                                :label="'Comment (optional)' | translate"
                              >
                              <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>
                              </v-textarea>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-tab-item>
                    </v-tabs>

                    <v-row v-if="editDocument">
                      <v-col cols="12" sm="12">
                        <v-textarea
                          outlined
                          name="comment"
                          v-model="comment"
                          autocomplete="off"
                          :label="'Comment (optional)' | translate"
                        >
                        <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                        </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="closeBox()">{{ 'Close' | translate }}</v-btn>
            <v-btn color="green darken-1" v-if="editDocument" text @click='editPersonalDocument()'>{{ 'Update' | translate }}</v-btn>
            <v-btn color="green darken-1" v-else text @click='uploadDocument'>{{ 'Upload' | translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="messagedialog" v-if="messagedialog" persistent max-width="700">
        <v-spacer></v-spacer>
        <v-card class="py-8 px-6 text-xl-center ">
          <v-card-title class="headline">{{ inboxMessage.subject}}</v-card-title>

          <v-card-text>
            <div v-html="inboxMessage.body"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <Message
                v-if="inboxMessage.from_user.user_id"
                :buttontext="'Reply'"
                class="mx-1"
                :color="'info'"
                type="users"
                :sendUserList="inboxMessage.from_user.user_id"
                :notificationId="inboxMessage.id"
            />
            <v-btn color="green darken-1" text @click="closeMessage()">{{ 'Close' | translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-if="exerciseDialog" v-model="exerciseDialog" persistent>
      <v-card v-if="exercise.exercise_id" class="test-container">
        <v-stepper v-model="stage">
          <v-stepper-header>
            <v-stepper-step :complete="stage > 1" step="1">
              {{ "Instructions" | translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stage > 2" step="2">
              {{"Exercise"| translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">
              {{ "Results" | translate }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items v-bind:style="{ 'background-color': '#f7f7f7' }">
            <v-stepper-content step="1">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-row class="ma-3">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" md="9" sm="12">
                        <v-card-title
                          class="text-h5"
                          v-text="exercise.exercise_name"
                        ></v-card-title>
                        <v-card-subtitle
                          v-text="exercise.exercise_description"
                        ></v-card-subtitle>
                      </v-col>
                      <v-col cols="12" md="3" sm="12">
                        <v-avatar class="grey" size="125" tile>
                          <v-img
                            v-if="exercise.exercise_image"
                            :src="storage_url + exercise.exercise_image"
                          ></v-img>
                        </v-avatar>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-3">
                  <v-col>
                    <div>
                      <v-card-subtitle>
                        <div class="mb-n3">
                          <p v-html="exercise.first_page_details"></p>
                        </div>
                      </v-card-subtitle>
                    </div>
                  </v-col>
                </v-row>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text"
                  :color="primary_color"
                  @click="startExerciseStage2"
                >
                  {{ "Next" | translate }}</v-btn
                >
                <v-btn text @click="exerciseDialog = false">
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mx-auto pa-5"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
            
              <v-card-subtitle>

                <div class="mb-n3">
                  <p v-html="exercise.middle_page_details"></p>
                </div>

                <div id="download-container">
                  <v-btn
                    class="mt-4"
                    :color="primary_color"
                    @click=getDownloadLink(exercise);
                    outlined
                    rounded
                    small
                  >
                    {{ "Download Exercise Question" | translate }}</v-btn
                  >
                </div>

                <div id="file-upload-view-container">
                  <div id="iframe-container" class="iframe-container">
                  </div>
                  <div id="imageContainer" class="pa-4"></div>
                </div>

                <div class="upload-exercise-container" v-if="lastExerciseGraded && lastExerciseGraded.hasOwnProperty('grade')">
                  <v-form id="modelform" ref="modelform" v-if="lastExerciseGraded.grade==null">
                    <v-row>
                      <v-col cols="6">
                        <v-textarea
                            outlined
                            name="comments"
                            v-model="comments"
                            :rules="[v => !!v || 'Please enter your comments']"
                            :label=" 'Comments' | translate"
                            @keyup="checkifAnswered()"
                        >
                        <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                        </template>                   
                        </v-textarea>
                      </v-col>
                      <v-col cols="6">
                        <v-btn-toggle v-model="exerciseGradeResult" @change="checkifAnswered()" rounded>
                          <v-btn value="fail" :color="exerciseGradeResult === 'fail' ? 'red darken-1' : ''" :class="exerciseGradeResult === 'fail' ? 'white--text' : ''">
                            <v-icon :class="exerciseGradeResult === 'fail' ? 'white--text' : ''">mdi-thumb-down</v-icon>{{'FAIL' | translate}}
                          </v-btn>

                          <v-btn value="pass" :color="exerciseGradeResult === 'pass' ? 'green' : ''" :class="exerciseGradeResult === 'pass' ? 'white--text' : ''">
                            {{'PASS' | translate}} <v-icon :class="exerciseGradeResult === 'pass' ? 'white--text' : ''">mdi-thumb-up</v-icon>
                          </v-btn>
                        </v-btn-toggle>
                      </v-col>
                    </v-row>
                   
                  </v-form>
              
                  <v-btn
                    class="white--text mt-n1"
                    :color="primary_color"
                    :disabled="!canSubmit"
                    @click="submitExercisegrade"
                  >
                    {{ "Submit" | translate }} 
                  </v-btn>
                  <span v-if="canSubmit" class="primary--text">
                    {{ '*You ( ' | translate }} {{ currentUser.name}} {{ ') are grading this exercise as ' | translate}} <span class="text-uppercase">{{ exerciseGradeResult | translate}}</span>
                  </span>
                  <span v-if="lastExerciseGraded.grade" class="primary--text">
                    {{ 'This Exercise is already graded' | translate }}
                  </span>
                </div>
               
                <v-divider></v-divider>

                <div>
                  <v-data-table
                    v-if='exercise.exercise_files'
                    :headers="exerciseAnswerHeaders" :items="exercise.exercise_files"
                  >
                  <template v-slot:top>
                    <v-card-title>
                      {{  'Uploaded Answers' | translate }} 
                      <v-spacer></v-spacer>
                    </v-card-title>
                    </template>
                    <template slot="no-data">
                        {{ 'No data available' | translate }}
                    </template>
                    
                    <template v-slot:item="{ item }">
                          <tr style="cursor:pointer;">
                            <td>{{ item.id }}</td>
                            <td>{{ item.comment?item.comment: 'No comments added' | translate}}</td>
                            <td>{{ item.grade?item.grade: "Not yet graded"| translate  }}</td>
                            <td> 
                              <v-btn small class="mt-2" target="_blank" color="primary" @click="getUploadedExerciseAnswer(exercise, item)"><v-icon>mdi-download</v-icon></v-btn>
                            </td>
                          </tr>
                      </template>

                    <template v-slot:footer.page-text="items"> 
                      {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                    </template>
                  </v-data-table>
                   
                </div>

              </v-card-subtitle>

              </v-card>

              <v-card
                class="mx-auto mt-2 footer-buttons"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn text @click="exerciseDialog = false;
                stage = 1;">
                  {{ "Close / Grade later" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-card
                  class="mx-auto result-box"
                  elevation="0"
                >
                  <v-row>
                    <v-col>
                      <div>
                        <h2 class="text-center text-uppercase">
                          {{ "Result" | translate }}
                        </h2>  
                        <v-card-subtitle>
                          <div class="mb-n3">
                            <p v-html="exercise.last_page_details_for_admin"></p>
                          </div>
                        </v-card-subtitle>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  text
                  @click="
                    exerciseDialog = false;
                    stage = 1;
                  "
                >
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      <v-card v-else>
        <v-card-title>
          {{ "There is no Data to show" | translate }}
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="exerciseDialog = false"
            >{{ "Close" | translate }}</v-btn
          ></v-card-title
        >
      </v-card>
    
     <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    </v-dialog>

          <v-dialog v-if="eventDialog" v-model="eventDialog" persistent>
              <v-card class="event-container">
                <v-stepper v-model="stage">
                  <v-stepper-header>
                    <v-stepper-step :complete="stage > 1" step="1">
                      {{ "Event Participation Check" | translate }}
                    </v-stepper-step>
                  </v-stepper-header>

                  <v-stepper-items v-bind:style="{ 'background-color': '#f7f7f7' }">

                    <v-stepper-content step="1">
                      <v-card
                        class="mx-auto pa-5"
                        max-width="800"
                        style="min-height: 400px; overflow-y: scroll"
                      >

                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title class="text-h5">
                              {{ event.subject }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-icon class="mr-2">mdi-clock-time-three-outline</v-icon>{{ convertDate(event.start.dateTime) }} {{ getTimeSlot(event.start.dateTime, event.end.dateTime) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>


                      <v-card-subtitle>

                        <div class="mb-n3">
                          <p v-html="event.body.content"></p>
                        </div>

                        <div>
                          <v-form id="participationcheckform" ref="participationcheckform">
                            <v-row v-for="(attendee,aindex) in event.attendees" :key="aindex">
                             
                              <v-col cols="8">
                              Did <b>{{ attendee.emailAddress.name }}</b> with email address <b>{{ attendee.emailAddress.address }}</b> participate in the event?
                              </v-col>
                              
                              <v-col cols="4" class="mt-n4">

                                <v-btn-toggle v-model="attendanceStatus[aindex]"  rounded @change="markAttendance(attendanceStatus[aindex],attendee.emailAddress.address)"> 
                                  <v-btn value="no" :color="attendanceStatus[aindex] === 'no' ? 'red darken-1' : ''" :class="attendanceStatus[aindex] === 'no' ? 'white--text' : ''" >
                                    <v-icon :class="attendanceStatus[aindex] === 'no' ? 'white--text' : ''">mdi-thumb-down</v-icon>{{'NO' | translate}}
                                  </v-btn>

                                  <v-btn value="yes" :color="attendanceStatus[aindex] === 'yes' ? 'green' : ''" :class="attendanceStatus[aindex] === 'yes' ? 'white--text' : ''">
                                    {{'YES' | translate}} <v-icon :class="attendanceStatus[aindex] === 'yes' ? 'white--text' : ''">mdi-thumb-up</v-icon>
                                  </v-btn>
                                </v-btn-toggle>

                              </v-col>
                            </v-row>
                          
                          </v-form>

                          <v-spacer></v-spacer>
                          <v-btn
                            class="white--text mt-5"
                            :color="primary_color"
                            :disabled="!canSubmit"
                            @click="submitParticipationList"
                          >
                            {{ "Submit" | translate }} 
                          </v-btn>
                        </div>

                      </v-card-subtitle>

                      </v-card>

                      <v-card
                        class="mx-auto mt-2 footer-buttons"
                        max-width="800"
                        v-bind:style="{ 'background-color': '#f7f7f7' }"
                        elevation="0"
                      >
                        <v-btn text @click="eventDialog = false;
                        stage = 1;">
                          {{ "Close" | translate }}
                        </v-btn>
                      </v-card>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-card>
          </v-dialog>

        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>


<script>
import store from "@/store"
import { mapGetters, mapState  } from "vuex"
import { FETCH_USER_DOCUMENTS,
  UPDATE_USER_DOCUMENT,
  FETCH_USERS,
  FETCH_GROUPS,
  FETCH_CREATE_DOCUMENT,
  CLEAR_INBOX_SETTINGS,
  FETCH_INBOX_SETTINGS,
  SAVE_UPDATE_INBOX_SETTINGS,
  FETCH_INBOX_MESSAGES,
  FETCH_SENT_MESSAGES,
  FETCH_INDIVIDUAL_NOTIFICATION,
  MARK_NOTIFICATION_AS_READ,
  FETCH_ALL_EXERCISES,
  DOWNLOAD_EXERCISE_TEMPLATE,
  FETCH_USER_UPLOADED_EXERCISE_ANSWERS,
  FETCH_PAST_EVENTS,
  UPDATE_EXERCISE_USER_ANSWERS_GRADE,
  SAVE_UPDATE_ATTENDEEE_EVENT
} from "@/store/actions.type"
import { SET_LOADING, SET_ROUTER_ENTER, SET_SNACKBAR, SET_DOCUMENTS_ERROR } from "@/store/mutations.type"

export default {
  name: "Inbox",
  async beforeRouteEnter(to, from, next) {
    if (store.state.auth.user.roles.includes(1) || store.state.auth.user.roles.includes(3)) {
      Promise.all([
        store.dispatch(FETCH_GROUPS, ""),
        store.dispatch(FETCH_USERS, ''),
      ]).finally(()=>{
          store.commit(SET_LOADING, false)
                  
      })
    }
    if (store.state.auth.user.roles.includes(1) || store.state.auth.user.roles.includes(3) || store.state.auth.user.permissions.includes('has-access-to-pending-exercise')) {
      await store.dispatch(FETCH_ALL_EXERCISES,'?status=uploaded')
    }
    Promise.all([
      await store.dispatch(FETCH_USER_DOCUMENTS,'?status=active'),
      await store.dispatch(FETCH_CREATE_DOCUMENT,'initialize')
    ]).finally(()=>{
        store.commit(SET_LOADING, false);
        store.commit(SET_ROUTER_ENTER, false)
    })

    return next();
  },
  data: function() {
    return {
      title: "Items Board",
      search: "",
      createsearch: "",
      singleSelect: "",
      settingsdialog : false,
      set_name_stage_1: null,
      set_name_stage_2: null,
      due_days_stage_1: null,
      due_days_stage_2: null,
      stage1search: "",
      stage2search: "",
      valid: 'true',
      checkAllGroups: false,
      checkAllUsers: false, 
      selectedUsers: [],
      selectedGroups: [], 
      primary_color: '',
      isSearching: false,
      templatetitle: null,
      custommetadata: {},
      due_date: null,
      templatedialog: false,
      editDocument: false,
      doc_id: null,
      updateMessage: null,
      editMessage: null,
      updateSlug: null,
      main_template_id: null,
      metadatakeys:[],
      datacustom: {},
      formMessage: null,
      file: null,
      filetemplate: null,
      status: null,
      comment: null,
      menu: false,
      has_tutor_products:false,
      messagedialog: false,
      inboxMessage:null,
      isReadCount:0,
      sentMessages:[],

      //Exercises
      stage: 1,
      exercise: [],
      exerciseDialog: false,
      fileURL: null,
      lastCourseId: null,
      isLoading: false,
      storage_url: null,
      company_storage_url: null,
      comments: null,
      exerciseGradeResult: null,
      canSubmit: false,
      lastExerciseGraded:null,
      gradeOptions: [
        { label: "Fail", value: "fail" },
        { label: "Pass", value: "pass" }
      ],

      //Events
      event : null,
      eventDialog : false,
      last_limit: 10,
      attendanceStatus: [],
      attendeeList:[],
      absentList: [] 

    };
  },
  created() {
    this.getallMessages();
    this.storage_url = process.env.VUE_APP_STORAGE_URL
    this.company_storage_url = process.env.VUE_APP_COMPANYADMIN_STORAGE_URL;
  },
  methods: {
    async getallMessages(){
      await store.dispatch(FETCH_INBOX_MESSAGES, '?type=inbox&is_read=0').then((resp) => {
        if (resp.success) {
          this.isReadCount = resp.data.length;
        }
      })
      store.dispatch(FETCH_INBOX_MESSAGES, '?type=inbox')

    },
    closeMessage(){
      this.messagedialog = false;
      this.getallMessages();
    },
    async showView(id){
      this.messagedialog = true;
      await store.dispatch(FETCH_INDIVIDUAL_NOTIFICATION, id).then((resp) => {
        if (resp.success) {
          this.inboxMessage = resp.data;

          store.dispatch(MARK_NOTIFICATION_AS_READ, {
              id: id,
              is_read: 1,
            });
          store.commit(SET_LOADING, false);
          store.commit(SET_ROUTER_ENTER, false);
        }
      });
    },
    fileForm() {
      this.formMessage = null
      document.getElementById('document_file').value=''
      this.comment=''
      this.$refs.fileformData.reset()
      if(this.$refs.customformData != undefined) {
        this.$refs.customformData.reset()
      }
    },
    customForm () {
      this.formMessage = null
      this.comment = ''
      document.getElementById('document_file').value=''
      this.$refs.fileformData.reset()
      this.$refs.customformData.reset()
    },
    saveMetaData(index,internalindexvalue, id) {
      const value = document.getElementById(id).value
      this.custommetadata[index][internalindexvalue].value = value
    },
    showCustomHeader(customkey) {
      let status = false
      this.custommetadata[customkey].forEach(metadata =>{
        if(metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number'){
          status =true
        }
      })
      return status
    },
    onFileSelectedTemplate() {
      this.filetemplate = document.getElementById("document_file").files[0];
    },
    async getInboxData(){

    Promise.all([
      await store.dispatch(FETCH_USER_DOCUMENTS,'?status=active&user_ids='+this.selectedUsers+'&group_ids='+this.selectedGroups),
      await store.dispatch(FETCH_CREATE_DOCUMENT,'initialize?user_ids='+this.selectedUsers+'&group_ids='+this.selectedGroups)
    ]).finally(()=>{
        if(this.settingsdialog){
          this.set_name_stage_1 = ''
          this.due_days_stage_1  = ''
          this.set_name_stage_2 = ''
          this.due_days_stage_2 = ''                
          this.settingsdialog = false
          this.$refs.form.reset()
        }
        this.$store.commit(SET_LOADING, false);
        this.$store.commit(SET_ROUTER_ENTER, false)
    })
    },
    async getEvents(){
      if (store.state.auth.user.roles.includes(1) || store.state.auth.user.roles.includes(3) || store.state.auth.user.permissions.includes('has-access-to-register-participation')) {
        await store.dispatch(FETCH_PAST_EVENTS,'?last_limit='+this.last_limit)
      }
    },
    async getSentMessages(){
      await store.dispatch(FETCH_SENT_MESSAGES, '?type=sent').then((resp) => {
        if (resp.success) {
          this.sentMessages = resp.data;
        }
      })
    },
    checkboxUpdated(flag){
      if(flag == "groups" && this.checkAllGroups){
          this.selectedGroups = []
          this.selectedGroups = this.groups.map(data=>data.group_id)
          this.selectedUsers = []
          this.checkAllUsers = false   
      }
      else if(flag=="groups" && this.checkAllGroups == false){
        this.selectedGroups = []
        this.selectedUsers = []
        this.checkAllUsers = false   
      }
      else if(flag == "users" && this.checkAllUsers){
        this.selectedUsers = []
        this.selectedUsers = this.users.map(data=>data.user_id)        
      }
      else if(flag== "users" && this.checkAllUsers == false){
        this.selectedUsers = []
      }

    },
    showCustomForm () {
      let status = false
      for(let data in this.custommetadata) {
        this.custommetadata[data].forEach(metadata => {
          if(metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number') {
            status = true
          }
        })
      }
      return status
    },
    documentOpenModal (data) {
      const {title, templatedata, updateMessage, updateSlug } = data
      let currentDate = new Date()
      let validdate = new Date()
      if(templatedata.days_until != "---") {
        validdate.setDate(currentDate.getDate()+templatedata.days_until)
      }
      else{
        validdate.setDate(currentDate.getDate()+ 30)
      }
      this.due_date = validdate.toISOString().slice(0,10)
      this.templatetitle = title
      if(templatedata && templatedata.temp_file != undefined){
        if(JSON.parse(templatedata.temp_file.temp_meta_data) !== null && typeof JSON.parse(templatedata.temp_file.temp_meta_data === "object")){
          this.metadatakeys = Object.keys(JSON.parse(templatedata.temp_file.temp_meta_data))
          this.custommetadata = JSON.parse(templatedata.temp_file.temp_meta_data)
        }
      }
      this.main_template_id = templatedata.item_id
      this.doc_id= templatedata.temp_id
      this.comment  = templatedata.comment != undefined ? templatedata.comment : ''
      this.updateSlug = updateSlug
      this.updateMessage = updateMessage
      this.templatedialog = true
      this.status = templatedata.status
    },
    templateBoxClose () {
      this.templatetitle = '';
      this.custommetadata = {};
      this.due_date = null
      this.main_template_id = null
      this.doc_id= null
      this.updateSlug = ''
      this.updateMessage = ''
      this.templatedialog = false
      this.$store.commit(SET_DOCUMENTS_ERROR, [])
    },
    closeBox(){
      if(!this.editDocument) {
        document.getElementById('document_file').value=''
      }
      document.getElementById("modelform").reset();
      this.templatedialog = false
      this.editDocument = false
      this.status = null
      this.formMessage = null
    },
    async clearFilter(){
      this.checkAllGroups = false
      this.checkAllUsers = false      
      this.selectedGroups = []
      this.selectedUsers = []
      await this.getInboxData()
    },
    async openSettingsDialog(){
      await this.$store.dispatch(FETCH_INBOX_SETTINGS,'inbox').then( resp =>{
        if(resp.success){
          this.set_name_stage_1 = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_1.set_name : "")
          this.set_name_stage_2 = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_2.set_name : "")
          this.due_days_stage_1  = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_1.due_days : "")
          this.due_days_stage_2  = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_2.due_days : "")
          this.settingsdialog = true
          store.commit(SET_LOADING, false)
        }
      })      
    },
    closeSettingsDialog(){
      this.settingsdialog = false
      this.$refs.form.reset()      
      this.set_name_stage_1 = ''
      this.due_days_stage_1  = ''
      this.set_name_stage_2 = ''
      this.due_days_stage_2 = ''

    },
     clearsettings(){
     this.$store.dispatch(CLEAR_INBOX_SETTINGS,'inbox').then( async resp =>{
        if(resp.success){
            this.settingsdialog = false
            this.$refs.form.reset()                
            this.set_name_stage_1 = ''
            this.due_days_stage_1  = ''
            this.set_name_stage_2 = ''
            this.due_days_stage_2 = ''
            this.getInboxData()
        }
      })      
    },      
    uploadDocument () {
      if (this.$refs.modelform.validate()) {
          if(( this.$refs.customformData !=undefined  && this.$refs.customformData.validate()) || (this.$refs.fileformData !=undefined && this.$refs.fileformData.validate())) { 
            this.formMessage = null
          }
          else {
            this.formMessage = "Please fill custom form or file form completely"
            return ;             
          }

          var formData = new FormData(document.getElementById("modelform"));
          
          if(this.filetemplate != null && this.filetemplate != undefined && this.filetemplate != '') {
            formData.set("file", this.filetemplate)
          }
          else {
            formData.delete("file")
          }
          
          formData.set("item_id", this.main_template_id)
          formData.set("temp_id", this.doc_id)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)

          if(this.filetemplate == null || this.filetemplate == undefined || this.filetemplate == '')
          formData.set('temp_meta_data',JSON.stringify(this.custommetadata))

          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
                  store.commit(SET_SNACKBAR, {status: true, message: this.updateMessage })
                  this.getInboxData()
                  this.$refs.modelform.reset()
                  this.templatedialog =false
                  this.doc_id = null
                  this.file=  null
                  this.comment  = null
                  this.due_date = null
                  this.status = null
                  this.editDocument = false
                  this.main_template_id = null
                  this.updateMessage = null
                  store.commit(SET_LOADING, false)

            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    
    checkifAnswered(){
      if((!this.exerciseGradeResult) || (this.comments === '' || this.comments===null)){
        this.canSubmit = false;
      }
      else{
        this.canSubmit = true;
      }
    },
    markAttendance(status, currentUser) {
        if (status === 'yes') {
          const isUserInList = this.attendeeList.includes(currentUser)
          const isUserInWrongList = this.absentList.includes(currentUser)
          if(!isUserInList){
            this.attendeeList.push(currentUser); // Add the current user to the attendee list
          }
          if(isUserInWrongList){
            const indexToRemove = this.absentList.findIndex((x) => x === currentUser);
            if (indexToRemove !== -1) {
              this.absentList.splice(indexToRemove, 1);
            }

          }
        }
        else{
          const isUserInList = this.absentList.includes(currentUser)
          const isUserInWrongList = this.attendeeList.includes(currentUser)
          if(!isUserInList){
            this.absentList.push(currentUser); // Add the current user to the absent list
          }
          if(isUserInWrongList){
            const indexToRemove = this.attendeeList.findIndex((x) => x === currentUser);
            if (indexToRemove !== -1) {
              this.attendeeList.splice(indexToRemove, 1);
            }
          }
        }

        if(this.event.attendees.length == (this.attendeeList.length + this.absentList.length)){
          this.canSubmit = true;
        }
    },
    async startExerciseStage2(){
      this.startTime = new Date();
      this.stage = 2
      this.getUploadedExerciseAnswerView(this.exercise, this.getLatestExerciseFile(this.exercise));
    },
    async callExercise(courseId,exercise,exercise_type) {
      this.isLoading = true;
      this.lastCourseId = courseId;
      this.exercise = exercise;
      this.exercise.exercise_type = exercise_type;
      this.isLoading = false;
      this.exerciseDialog = true;
      this.$store.commit(SET_LOADING, false)
    },
    async callEventParticipation(eventId,event) {
      this.event = event;
      this.eventDialog = true;
    },
    async getDownloadLink(exercise){
      this.$store.dispatch(DOWNLOAD_EXERCISE_TEMPLATE, 'view-file/'+exercise.exercise_id+'?exercise_type='+exercise.exercise_type+'&user_id='+exercise.user.user_id).then(async resp =>{
          if(resp != undefined && resp.hasOwnProperty('success') == false){
              this.fileURL = URL.createObjectURL(resp.data);                  
              let fileLink = document.createElement('a');
              fileLink.href = this.fileURL;
              fileLink.setAttribute('download', exercise.exercise_template);
              const container = document.getElementById("download-container"); // Change to the ID of your container
              container.appendChild(fileLink);
              fileLink.click(); 
              await this.$store.commit(SET_LOADING, false)     
          }
        })
    },
    async getUploadedExerciseAnswer(exercise, file){
      await store.dispatch(FETCH_USER_UPLOADED_EXERCISE_ANSWERS,file.id+'?exercise_type='+exercise.exercise_type+'&user_id='+exercise.user.user_id).then(async resp => {
          if(resp != undefined && resp.hasOwnProperty('success') == false){
              this.fileURL = URL.createObjectURL(resp.data);                  
              let fileLink = document.createElement('a');
              fileLink.href = this.fileURL;
              fileLink.setAttribute('download', this.getLatestExerciseFile(exercise).exercise_file);
              const container = document.getElementById("download-container"); // Change to the ID of your container
              container.appendChild(fileLink);
              fileLink.click(); 
              await this.$store.commit(SET_LOADING, false)     
          }
        })
      
    },
    async getUploadedExerciseAnswerView(exercise, file){
      this.lastExerciseGraded = file;
      await store.dispatch(FETCH_USER_UPLOADED_EXERCISE_ANSWERS,file.id+'?exercise_type='+exercise.exercise_type+'&user_id='+exercise.user.user_id).then(async resp => {
          if(resp != undefined && resp.hasOwnProperty('success') == false){
              let extension = (this.getLatestExerciseFile(exercise).exercise_file).split('.').pop();
              if(['png','jpg','jpeg'].includes(extension)){
                this.fileURL = URL.createObjectURL(resp.data);    
                let fileLink = document.createElement('a');
                fileLink.href = this.fileURL;
                fileLink.setAttribute('download', this.getLatestExerciseFile(exercise).exercise_file);
                document.body.appendChild(fileLink);

                const imageElement = document.createElement('img');
                imageElement.src = this.fileURL;
                imageElement.alt = 'Image from Blob Data';
                imageElement.style.width = '90%';
                const imageContainer = document.getElementById('imageContainer');
                imageContainer.appendChild(imageElement);
              }
              else if(extension == 'pdf'){
                this.file = new Blob([resp.data], {type: 'application/pdf'});
                this.fileURL = URL.createObjectURL(this.file);

                const iframeElement = document.createElement('iframe');
                iframeElement.src = this.fileURL+'#toolbar=0'; // Set the URL for the iframe content
                iframeElement.style.width = '100%'; // Set the width as needed
                iframeElement.style.height = '400px'; // Set the height as needed

                // Append the iframe element to a container (e.g., a div with the id 'iframeContainer')
                const iframeContainer = document.getElementById('iframe-container');
                iframeContainer.appendChild(iframeElement);
                // <iframe v-if="fileURL != null && exercise.exercise_files[0]" id="iframemodule" :src="fileURL+'#toolbar=0'" style="border: 0;height: 100%;left: 0; position: absolute; top: 0; width: 100%;" allowfullscreen></iframe>                  

            }

              await this.$store.commit(SET_LOADING, false)     
          }
        })
      
    },
    async submitExercisegrade() {
      this.isTestLoading = true;
      await store.commit(SET_LOADING, true)
      let params={
          "exercise_id": this.getLatestExerciseFile(this.exercise).id,
          "comment": this.comments,
          "grade":this.exerciseGradeResult,
          "exercise_type": this.exercise.exercise_type=='App\\UserMandatoryExercise'?'mandatory':'training',
        }
      await store
        .dispatch(UPDATE_EXERCISE_USER_ANSWERS_GRADE, params )
        .then(async resp => {
          if (resp != undefined && resp.success) {
            this.$store.commit(SET_SNACKBAR, {status: true, message: "Exercise was graded successfully!"});
            this.stage = 3
            this.$store.commit(SET_LOADING, false)
            this.isTestLoading = false;
            this.testExamDialog = true;
            await store.dispatch(FETCH_ALL_EXERCISES, '?status=uploaded');
          }
        }) 
        .catch(err => {
            this.isTestLoading = false;
            this.testExamDialog = false;
            this.feedbackMessage = err.response.data.message;
            this.feedbackDialog=true;
        });
      return;
    },
    submitParticipationList(){
      this.isLoading = true;
      if (this.$refs.participationcheckform.validate()) {
         this.$store.dispatch(SAVE_UPDATE_ATTENDEEE_EVENT, {
          'ms_event_id':this.event.id,
          'attendees_email':this.attendeeList,
          'not_attendees_email':this.absentList,
        }).then(async resp => {
          if(resp != undefined && resp.hasOwnProperty('success') && resp.success){
            this.eventDialog = false;
            this.$store.commit(SET_SNACKBAR, {status: true, message: "Participation Details saved successfully!"});
            this.$store.commit(SET_LOADING, false)
            this.isLoading = false;
            this.getEvents();        
          }
        });

      }

    },
    getLatestExerciseFile(exercise){
      const objectWithHighestId = exercise.exercise_files.reduce((maxObject, currentObject) => {
          if (!maxObject || currentObject.id > maxObject.id) {
            return currentObject;
          }
          return maxObject;
        }, null);

        return objectWithHighestId;
    },
    setFilter(){
      if (this.$refs.form.validate()) {
         this.$store.dispatch(SAVE_UPDATE_INBOX_SETTINGS, {
          'stage_1':{ set_name: this.set_name_stage_1, due_days: this.due_days_stage_1 },
          'stage_2':{ set_name: this.set_name_stage_2, due_days: this.due_days_stage_2 }
        }).then(async resp => {
          if(resp != undefined && resp.hasOwnProperty('success') && resp.success){
            this.getInboxData()        
          }
          else{
            store.commit(SET_LOADING, false)
          }

        });

      }
    },
    stripHTML(html){
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },

    convertDate(date){
      var dateFormat =new Date(date);
      const options = { day: 'numeric', month: 'long', year: 'numeric' };
      return dateFormat.toLocaleDateString(this.currentUser.lang_code, options);
    },
    getTimeSlot(start,end){
      const startTime = new Date(start);
      const endTime = new Date(end);

      const startHours = startTime.getHours().toString().padStart(2, '0');
      const startMinutes = startTime.getMinutes().toString().padStart(2, '0');

      const endHours = endTime.getHours().toString().padStart(2, '0');
      const endMinutes = endTime.getMinutes().toString().padStart(2, '0');

      return `${startHours}:${startMinutes} to ${endHours}:${endMinutes}`;
    }
  },
  mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    this.primary_color  = company_meta.primary_color

    if(this.currentUser.roles.includes(4) == true  && this.currentUser.is_group_user == false && company_meta.has_inbox == 'false'){
      this.$router.push('/dashboard')
    }

    if(company_meta.hasOwnProperty('has_tutor_products')){
      this.has_tutor_products = (company_meta.has_tutor_products==='true')
    }
  },  
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Header: () => import("@/components/header/Header"),
    Tutor: () => import("@/components/modal/Tutor"),
    Message: () => import("@/components/modal/Message"),
  },
  computed: {
    ...mapGetters(["userdocuments","currentUser", 'users' ,'groups','createdocuments','inboxsettings','curLanguage','inboxMessages','sentMessages','uploadedexercises','calendarpastevents']),
    ...mapState({
      documenterrors: state => state.documents.documenterrors
    }),
    inboxHeaders(){
      return [
        { text: this.$t("From"), value: "from_user" },
        { text: this.$t("Subject"), key: "subject", value: "message_subject" }, 
        { text: this.$t("Status"), value: "is_read" },
        { text: this.$t("Date"), key: "created_at", value: "message_created_at", sortable: false },
      ]
    },
    headers(){ 
        return [
        { text: this.$t("Name"), value: "item_name" },   
        { text: this.$t("Template name"), value: "temp_name" },
        { text: this.$t("Type"), value: "temp_type" }, 
        { text: this.$t("Due date"), value: "due_date" },
        { text: this.$t("Days until"), value: "days_until" },
        { text: this.$t("Action"), value: "linktouser", sortable: false }
      ]
    },
    createdocumentheaders(){ 
        return [
        { text: this.$t("Name"), value: "item_name" },   
        { text: this.$t("Template name"), value: "temp_name" },
        { text: this.$t("Type"), value: "temp_type" }, 
        { text: this.$t("Due date"), value: "due_date" },
        { text: this.$t("Days until"), value: "days_until" },
        { text: this.$t("Action"), value: "createdocumentaction", sortable: false }
      ]
    },
    exerciseheaders(){
      return [
        { text: this.$t("Name"), value: "exercise_name" },   
        { text: this.$t("Description"), value: "exercise_description" },
        { text: this.$t("Uploaded By User"), value: "exercise_name" },
        { text: this.$t("Course"), value: "course.course_name" },
        { text: this.$t("Course Expires on"), value: "course.course_name" },
        { text: this.$t("Result"), value: "latest_with_grade.grade" },
        { text: this.$t("Graded At"), value: "latest_with_grade.graded_at" },
      ]
    },
    exerciseAnswerHeaders(){
      return [
        { text: this.$t("Name"), value: "exercise_name" },   
        { text: this.$t("Comment"), value: "comment" },
        { text: this.$t("Grade"), value: "grade" },
        { text: this.$t("File Uploaded"), value: "grade" },
      ]
    },
    eventheaders(){
      return [
        { text: this.$t("Name"), value: "subject" },   
        { text: this.$t("Attendees"), value: "body" },
        { text: this.$t("Date"), value: "start.dateTime" },
      ]
    },
    isUser(){
      return this.currentUser.roles.includes(1) && this.currentUser.roles.length == 1 ? false:true
    },     
    stage1name(){ return [v => !!v || "Name is required"]},
    stage2name(){ return [v => !!v || "Name is required"]},
    duedays1(){ return [v => !!v || "Due days is required"]},
    duedays2(){ return [v => !!v || "Due days is required"]},
    fieldRules() { return [v => !!v || "Field is required"]},
    fileRules() { return [
      v => !!v || 'File is required',
      v => (v && v.size > 0) || 'File is required',
    ]},
    statusRules(){ 
      return [v => !!v || "Status is required"]
    },
    dateRules(){ 
      return [v => !!v || "Date is required"]
    },
    statusvalues(){ 
      return [
        { value: "active", text: this.$t("Active") },
        { value: "inactive", text: this.$t("Inactive") },
      ]
    }, 

  }
};
</script>
<style scoped>
.badge {
  padding: 2px 5px;
  font-weight: bold;
}
button {
  padding: 5px 10px;
  margin: 5px;
  border: 1px solid #ccc;
  cursor: pointer;
  background-color: #fff;
  transition: background-color 0.3s ease-in-out;
}

button.active {
  background-color: #e0e0e0; /* Add your active button style here */
}

.message-tab{
  background-color: #cccccc4b;
  border: 1px solid #000; 
  margin-top: 10px;
}

</style>